import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

// Get popular videos
export const getPopularVideos = async (page = 1, limit = 10) => {
  const response = await api.get('/videos/popular', {
    params: { page, limit }
  });
  return response.data;
};

// Get videos by series
export const getVideosBySeries = async (seriesId, page = 1, limit = 10, orderBy = 'created_at', order = 'DESC') => {
  const response = await api.get(`/videos/series/${seriesId}`, {
    params: { page, limit, order_by: orderBy, order }
  });
  return response.data;
};

// Get videos by category
export const getVideosByCategory = async (categoryId, page = 1, limit = 10, orderBy = 'created_at', order = 'DESC') => {
  const response = await api.get(`/videos/category/${categoryId}`, {
    params: { page, limit, order_by: orderBy, order }
  });
  return response.data;
};

// Get video by ID
export const getVideoById = async (id) => {
  const response = await api.get(`/videos/${id}`);
  return response.data;
};

// Get video by slug
export const getVideoBySlug = async (slug) => {
  const response = await api.get(`/videos/slug/${slug}`);
  return response.data;
};

// Get videos by language
export const getVideosByLanguage = async (language, page = 1, limit = 10, orderBy = 'created_at', order = 'DESC') => {
  const response = await api.get(`/videos/language/${language}`, {
    params: { page, limit, order_by: orderBy, order }
  });
  return response.data;
};

// Get similar videos
export const getSimilarVideos = async (videoId, limit = 6) => {
  const response = await api.get(`/videos/${videoId}/similar`, {
    params: { limit }
  });
  return response.data;
};

// Get popular non-series videos
export const getPopularNonSeriesVideos = async (page = 1, limit = 10) => {
  const response = await api.get('/videos/non-series/popular', {
    params: { page, limit }
  });
  return response.data;
};

// Get non-series videos by category
export const getNonSeriesVideosByCategory = async (categoryId, page = 1, limit = 10, orderBy = 'created_at', order = 'DESC') => {
  const response = await api.get(`/videos/non-series/category/${categoryId}`, {
    params: { page, limit, order_by: orderBy, order }
  });
  return response.data;
};

// Get non-series videos by language
export const getNonSeriesVideosByLanguage = async (language, page = 1, limit = 10, orderBy = 'created_at', order = 'DESC') => {
  const response = await api.get(`/videos/non-series/language/${language}`, {
    params: { page, limit, order_by: orderBy, order }
  });
  return response.data;
};

export default api;